<template>
  <div>
  <Card class="p-shadow-1">
        <template #title>
            Antes de iniciar a configuração
        </template>
        <template #content>
            <ul>
                <li>Cadastre todos os cargos e centros de custos listados no arquivo.</li>
                <li>Configure a(s) Escala(s) de Horários.</li>
                <li>Exemplo de nome do arquivo (cnpj.csv): <strong>1234589858.csv</strong>.</li>
                <li>Dados do arquivo CSV separdos por ponto e vírgula ( <strong>;</strong> ).</li>
                <li>Arquivo CSV sem cabeçalho.</li>
                <li>Máximo de caracteres do Nome: 50</li>
                <li>Máximo de caracteres do Crachá: 14</li>
                <li>Máximo de caracteres do Registro: 20</li>
                <li>Máximo de caracteres da Senha Biometria: 4</li>
                <li>Máximo de caracteres do E-mail: 50</li>
            </ul>
        </template>
        <template #footer>
            <div class="p-grid p-nogutter p-justify-between">              
               <Button label="Cancelar" @click="cancelar" icon="pi pi-times" class="p-button-secondary p-mr-2" />
               <Button label="Configurar"  @click="proximo" icon="pi pi-angle-right" iconPos="right" />
            </div>
        </template>
    </Card>
  </div>
</template>

<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        proximo() {
            this.$emit('nextPage', {formData: {}, pageIndex: -1});
        },
        cancelar() {
            this.$router.push('/cadastros/funcionarios');
        }
    }
}
</script>

<style>

</style>